<template lang="pug">
  div(v-if="!status")
    h2.mb-3 Selecciona la cuenta donde conectarás Shopify
    b-row.mb-4.align-items-center
      b-col(md="6")
        b-input-group
          b-form-input(placeholder="Buscar cuenta...", type="search", v-model="search_text")
          b-input-group-append
            b-button(variant="soft-secondary")
              .d-flex.align-items-center
                b-spinner(small, v-if="loading", variant="primary")
                search-icon.icon-sm(v-else)
                span.ml-2(v-if="$breakpoint.mdUp") Buscar
    b-row(v-if="accounts.length")
      b-col(md="6", v-for="(account, account_index) in accounts", :key="account_index")
        b-card
          b-row.align-items-center
            b-col
              small.text-help.uppercase Cuenta
              h4 {{ account.name }}
              p.text-help.mb-0 Última actualización {{ $moment(account.updatedAt).fromNow() }}
            b-col(cols="auto")
              b-button(variant="primary", @click="confirmConnect(account)") Seleccionar
      b-col(md="12")
        .d-flex.align-items-center.mb-3
          b-pagination.mb-0(:value="paginationCurrentPage", @change="paginationPageChanged($event, 'getAccounts')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount", v-if="v_paginationShow")
    empty-message(v-else, message="No hay cuentas")
  div(v-else)
    h3.text-success.text-center.mb-3 Cuenta conectada correctamente con Shopify
      shopping-bag-icon.ml-2
    .text-center
      b-button(center, variant="primary", :to="{name: 'account', params: { account_id: selected_account.account_id } }") Ir a cuenta
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const accountController = createNamespacedHelpers('account')
const organizationController = createNamespacedHelpers('organization')

import _debounce from 'lodash.debounce'

export default {
  data () {
    return {
      search_text: '',
      loading: false,
      status: null,
      selected_account: null
    }
  },
  computed: {
    ...accountController.mapState({
      accounts: state => state.accounts
    }),
    params () {
      return this.$route.query || {}
    },
  },
  methods: {
    ...mapActions(['account/all', 'auth/shopify']),
    sendParamsToBackend (account_id) {
      let self = this
      this.showLoadingScreen()

      this['auth/shopify']({
        ...self.params,
        account_id: account_id,
        clientId: '0e783d66dd80156ee9a026d804571b0f',
        state: 'konverza',
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
            self.status = false
          } else {
            self.$message.success('Cuenta conectada correctamente')
            self.status = true
          }
        }
      })
    },
    async confirmConnect (account) {
      try {
        let response = await this.$bvModal.msgBoxConfirm(`Estas por conectar Shopify a tu cuenta ${account.name}. ¿Deseas continuar?`, {
          title: 'Conectar Shopify',
          okVariant: 'success',
          okTitle: 'Continuar',
          cancelTitle: 'Cancelar'
        })

        if (response) {
          this.selected_account = account
          this.sendParamsToBackend(account.account_id)
        }
      } catch (e) {
        console.error(e.message)
      }
    }
  },
  mounted () {
    this.getAccounts = _debounce(() => {
      let self = this
      this.loading = true

      let params = {
        ...self.paginationParamsObject,
      }

      if (self.search_text) params.name = self.search_text

      this['account/all']({
        admin_id: self.getCurrentUser().admin_id,
        params,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      })
    }, 300, {leading: false, trailing: true})

    this.getAccounts()
  },
  watch: {
    search_text () {
      this.resetPaginationData()
      this.getAccounts()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
